import React from 'react'
import {useTranslation} from 'react-i18next'

import Overlay from 'src/designSystem/components/organisms/Overlay/Overlay'

/**
 * This template is named MakePaymentFailureTemplate rather than LoanPayFailureTemplate because it is agnostic enough to be used for other products in the future.
 *
 * It is co-located with LoanPayFailure right now because this it the only place it is used.
 *
 * This template is used to display a failure message (overlay) after a make loan payment has been submitted.
 * It displays a failure message and two buttons to try again or cancel.
 */

export type MakePaymentFailureTemplateProps = {
  onTryAgain: () => void
  onCancel: () => void
}

const MakePaymentFailureTemplate = (props: MakePaymentFailureTemplateProps): JSX.Element => {
  const {t} = useTranslation(['MakePaymentFailure', 'Common'])

  const {onTryAgain: handleOnTryAgain, onCancel: handleOnCancel} = props
  return (
    <Overlay
      visible
      title={t('SomethingWentWrong')}
      text={t('UnableToProcessPayment')}
      okayButtonText={t('Common:TryAgain')}
      onOkay={handleOnTryAgain}
      dismissButtonText={t('Common:Cancel')}
      onDismiss={handleOnCancel}
      testID="MakePaymentFailureOverlayModal"
    />
  )
}

export {MakePaymentFailureTemplate}
